define.alias("shared/utils/feature-requirements", "calendar/utils/feature-requirements");